import React, { useRef, useEffect, useState } from 'react';
//import Amplify, { API, Auth } from 'aws-amplify'
const Input = (props) => {
  const [value, setValue] = useState(props.default);
  const [values, setValues] = useState(props.values);
  const [original, setOriginal] = useState(props.default);
  const [updating, setUpdating] = useState(false);
  const [source, setSource] = useState(props.source);

  let unBlurFlag = false

  const inputRef = useRef();



  const onChange = (e) => {
    e.stopPropagation()
    let metadata = {
      [props.field]: e.target.value
    }
    setUpdating(true)

    let ids = []
    props.assets.forEach(o => {
      ids.push(o.id)
    })
    ids = ids.join(' OR ')


    props.assetHelper.updateBulk(`id:(${ids})`, metadata)

  }


  let newValues = []
  if (value === '(multiple values)') {
    newValues.push(
      <option selected>(multiple values)</option>
    )
  }


  values.forEach((o, i) => {
    if (o === value) {
      newValues.push(
        <option selected>{o}</option>
      )
    } else {
      newValues.push(
        <option >{o}</option>
      )
    }
  })
  let disabled = props.assets && props.assets.length === 0 ? true : false
  let showBoarder = "none"
  if (!disabled) {
    showBoarder = "1px solid lightgrey"
  }
  let style = {
    border: showBoarder
  }


  return (
    <>
      {updating ?
        <select disabled={disabled} onChange={onChange.bind(this)} style={{ border: '1px solid #0095e0' }} >
          {newValues}
        </select>
        :
        <select disabled={disabled} onChange={onChange.bind(this)} style={style} >
          {newValues}
        </select>
      }
    </>
  );
};

export default Input;



async function mySQLConnector(body) {
  //console.log({ checker: data })
  try {
    // const config = await API.post("authAPI", "/mysqlConnector", {
    //   'content-type': "text/plain",
    //   "access-control-allow-origin": "*",
    //   "body": body,
    //   "headers": {
    //     "x-api-key": window.apiKey
    //   }
    // });

    // return config
  } catch (err) { console.log(`error fetching config ${err}`) }
}
